"use client";
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import React, { useState } from "react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Forecastday, IweatherMarine } from "@/interfaces/IweatherMarine";
import { WeatherForcastDayCard, WeatherForcastDayModal } from "./Weathermodals";

const ForcastWeather: React.FC<{
  open: boolean;
  onclose: () => void;
  title?: string;
  subtitle?: string;
  weatherData: IweatherMarine | undefined;
  //   sx?: SxProps<Theme>;
}> = ({ open, onclose, weatherData }) => {
  const forecastdayData = weatherData?.forecast?.forecastday;

  const [weatherModalOpen, setWeatherModalOpen] = useState(false);
  const [selectedDataIndex, setSelectedDataIndex] = useState(-1);
  const [selectedDayWeatherData, setSelectedDayWeatherData] = useState<Forecastday | null>(null);

  const futureNextHandler = () => {
    if (forecastdayData && selectedDataIndex !== forecastdayData.length - 1) {
      setSelectedDayWeatherData(forecastdayData[selectedDataIndex + 1]);
      setSelectedDataIndex(selectedDataIndex + 1);
    }
  };

  const futurePrevHandler = () => {
    if (forecastdayData && selectedDataIndex !== 0) {
      setSelectedDayWeatherData(forecastdayData[selectedDataIndex - 1]);
      setSelectedDataIndex(selectedDataIndex - 1);
    }
  };
  return (
    <div>
      {" "}
      <Dialog
        open={open}
        onClose={onclose}
        maxWidth="lg"
        // fullScreen={fullScreen}
        fullWidth
        sx={{
          ".MuiDialog-paper.MuiPaper-root": {
            minHeight: "calc(90vh - 2rem)",
          },
          ".MuiPaper-root": {
            // borderRadius: fullScreen ? "0" : "14px",
          },
          ".MuiBackdrop-root": {
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <DialogTitle
          sx={{
            p: {
              xs: "10px 16px 10px",
              sm: "10px 16px 10px",
              md: "12px 18px 10px",
            },
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ position: "relative", top: "-2px" }}>
            Forecast Weather
            <Typography variant="body2" sx={{ mt: { xs: "-2px", md: "-4px" } }}>
              Check out weather at {weatherData?.location?.name} of next{" "}
              {weatherData?.forecast?.forecastday?.length} days
            </Typography>
          </Box>
          <Button
            sx={{
              minWidth: "unset",
              height: "fit-content",
              bgcolor: "#ccc",
              color: "#000",
              p: "7px",
              borderRadius: "10px",
              border: "1px solid #aaa",
            }}
            onClick={onclose}
            aria-label="Close"
          >
            <CloseRoundedIcon />
          </Button>
        </DialogTitle>

        <DialogContent sx={{ p: "1rem" }} dividers>
          <Box
            sx={{
              display: { xs: "grid", sm: "flex" },
              flexWrap: "wrap",
              gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "none" },
              gap: "1rem",
            }}
          >
            {weatherData?.forecast?.forecastday?.map((day, index) => (
              <WeatherForcastDayCard
                key={index}
                forecastday={day}
                onClick={() => {
                  setWeatherModalOpen(true);
                  setSelectedDayWeatherData(day);
                  setSelectedDataIndex(index);
                }}
              />
            ))}
          </Box>
        </DialogContent>
      </Dialog>
      <WeatherForcastDayModal
        open={weatherModalOpen}
        handleClose={() => setWeatherModalOpen(false)}
        dayWeather={selectedDayWeatherData}
        locationData={`${weatherData?.location?.name} , ${weatherData?.location?.country}`}
        nextHandler={futureNextHandler}
        prevHandler={futurePrevHandler}
        isNextDisable={
          (forecastdayData && selectedDataIndex == forecastdayData.length - 1) || false
        }
        isPrevDisable={selectedDataIndex == 0}
      />
    </div>
  );
};

export default ForcastWeather;
